<cipo-outline-field
    class="cipo-table-outline"
    [label]="fieldData()?.label"
    [markChanged]="fieldData()?.markChanged && valueChanged()"
    [error]="control()?.touched && control()?.invalid"
    [required]="control() && deepFieldData?.required()">
    @if (!loading() && tableFields()?.length) {
        <table
            #table
            mat-table
            [dataSource]="tableFormArray().controls"
            class="cipo-table"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
            cdkDropListData="dataSource">
            @for (column of tableColumns(); track $index) {
                @switch (column) {
                    @case ("position") {
                        <ng-container matColumnDef="position">
                            @let _showPosition = fieldData()?.showPosition;
                            <th mat-header-cell *matHeaderCellDef [class.counter]="_showPosition">
                                {{ _showPosition ? ("general.nr" | translate) : "" }}
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index">
                                <div fxLayout fxLayoutAlign="start center" fxLayoutGap="4px">
                                    @let empty = control()?.value?.[i]?.empty;
                                    @if (empty) {
                                        <ngx-skeleton-loader
                                            data-testid="table-cell-skeleton"
                                            [theme]="{
                                                width: '100%',
                                                height: '12px',
                                                marginBottom: 0,
                                            }"></ngx-skeleton-loader>
                                    }
                                    @if (!deepFieldData.readonly()) {
                                        <mat-icon class="cipo--cursor--move" cdkDragHandle>drag_indicator</mat-icon>
                                    }
                                    @if (!empty && _showPosition) {
                                        <span>{{ i + 1 }}</span>
                                    }
                                </div>
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                    }
                    @case ("action") {
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayoutAlign="end center">
                                        <button
                                            mat-icon-button
                                            [disabled]="externalDataLoading()"
                                            [attr.aria-label]="'a11y.common.add' | translate"
                                            (click)="insertRow()">
                                            <mat-icon aria-hidden="true">add</mat-icon>
                                        </button>
                                    </div>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index">
                                <div fxLayout fxLayoutAlign="end center">
                                    @let empty = control()?.value?.[i]?.empty;
                                    @if (empty) {
                                        <ngx-skeleton-loader
                                            data-testid="table-cell-skeleton"
                                            [theme]="{
                                                width: '100%',
                                                height: '12px',
                                                marginBottom: 0,
                                            }"></ngx-skeleton-loader>
                                    }
                                    @if (!empty && i !== activeRowIndex()) {
                                        <button mat-icon-button [disabled]="externalDataLoading()" [attr.aria-label]="'a11y.common.edit' | translate" (click)="editRow(i)">
                                            <mat-icon aria-hidden="true">edit</mat-icon>
                                        </button>
                                    }
                                    <button
                                        mat-icon-button
                                        color="warn"
                                        [disabled]="externalDataLoading()"
                                        [attr.aria-label]="'a11y.common.delete' | translate"
                                        (click)="deleteRow(i)">
                                        <mat-icon class="material-symbols-outlined" aria-hidden="true">delete</mat-icon>
                                    </button>
                                </div>
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                    }
                    @default {
                        <ng-container [matColumnDef]="column">
                            <th mat-header-cell *matHeaderCellDef [ngStyle]="{ width: columnWidths()[column] }">
                                <div fxLayout fxLayoutAlign="space-between center">
                                    <span class="cipo--text--ellipsed" [title]="columnsDictionary()[column].label">
                                        {{ columnsDictionary()[column].label }}
                                    </span>
                                    @let position =
                                        $index - (fieldData()?.showPosition || !deepFieldData.readonly() ? 1 : 0);
                                    @if (tableFields()[position]?.fieldDescription) {
                                        <mat-icon
                                            [title]="tableFields()[position].fieldDescription"
                                            class="material-symbols-outlined">
                                            info
                                        </mat-icon>
                                    }
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="cipo--align-content--start">
                                <div class="m-y-sm">
                                    @let empty = control()?.value?.[i]?.empty;
                                    @if (empty) {
                                        <ngx-skeleton-loader
                                            data-testid="table-cell-skeleton"
                                            [theme]="{
                                                width: '100%',
                                                height: '12px',
                                                marginBottom: 0,
                                            }"></ngx-skeleton-loader>
                                    } @else if (tableFieldsData()[i]) {
                                        <cipo-control
                                            [control]="tableFormArray().controls[i].controls[column]"
                                            [fieldData]="tableFieldsData()[i][column]" />
                                    }
                                </div>
                            </td>
                            <td mat-footer-cell *matFooterCellDef data-testid="table-field-footer-cell">
                                @let aggregateType = footerValuesDict()[column]?.aggregateFunctionType;
                                @if (hasFooter() && footerValuesDict()[column] && aggregateType) {
                                    <p class="p-l">
                                        {{ "SqlAggregateFunctionType." + aggregateType | translate }}
                                        {{ footerValuesDict()[column].aggregateValue }}
                                    </p>
                                }
                            </td>
                        </ng-container>
                    }
                }
            }

            <tr mat-header-row *matHeaderRowDef="tableColumns()"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: tableColumns()"
                cdkDrag
                [cdkDragDisabled]="deepFieldData.readonly() || externalDataLoading() || row?.empty"
                [cdkDragData]="row"
                cdkDragPreviewClass="cipo-table-drag-preview"></tr>
            @if (hasFooter()) {
                <tr mat-footer-row *matFooterRowDef="tableFooterColumns()"></tr>
            }
        </table>
    } @else {
        <ngx-skeleton-loader [theme]="{ width: '100%', height: '34px', margin: '0' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ width: '100%', height: '48px', margin: '0' }"></ngx-skeleton-loader>
    }
</cipo-outline-field>
@if (control()?.touched && control()?.invalid) {
    <p class="cipo-field-subscript m-l cipo-text--warn-900">
        @if (control().hasError("custom")) {
            {{ control().errors.custom }}
        } @else if (control().hasError("requiredTimeField")) {
            {{ "errors.requiredTimeField" | translate }}
        } @else {
            {{ "errors.required" | translate }}
        }
    </p>
}
